import OrderDTO from "@/dto/order/OrderDTO";
import { uuid } from "@/utils";

export const dzAdminHost = "https://dz-admin.laihuo.cn";

// const allowOrigins = ["http://localhost:5173", "https://dz-admin.laihuo.cn"];

/**
 *  判断是否已经登陆过来火v2
 */
export function hasLoginLaihuoV2() {
    return new Promise<boolean>((yes, no) => {
        const timer = setTimeout(() => {
            document.removeChild(iframe);
            window.removeEventListener("message", onMessage);

            no();
        }, 60000);

        function onMessage(event) {
            const data = event.data;

            if (data?.type === "HAS_LOGIN") {
                document.body.removeChild(iframe);
                window.removeEventListener("message", onMessage);
                clearTimeout(timer);

                return yes(data?.data?.hasLogin);
            }
        }

        window.addEventListener("message", onMessage);

        const iframe = document.createElement("iframe");

        iframe.src = `${dzAdminHost}/has_login`;

        iframe.style.visibility = "hidden";
        iframe.style.left = "-1000px";
        iframe.style.top = "-1000px";

        document.body.appendChild(iframe);
    });
}

export function pushOrderToFactory(orders: OrderDTO[]) {
    return new Promise<void>((yes, no) => {
        const iframe = document.createElement("iframe");

        iframe.src = `${dzAdminHost}/push_order_to_factory`;
        iframe.style.visibility = "hidden";
        iframe.style.left = "-1000px";
        iframe.style.top = "-1000px";

        document.body.appendChild(iframe);

        let id = uuid();

        function onMessage(event) {
            const data = event.data;

            const type = data?.type;

            if (type === "READY") {
                iframe.style.visibility = "";
                iframe.style.position = "fixed";
                iframe.style.zIndex = "1000";
                iframe.style.left = "0";
                iframe.style.top = "0";
                iframe.style.width = "100%";
                iframe.style.height = "100%";

                iframe.contentWindow?.postMessage({ id, type: "PUSH_ORDER_TO_FACTORY", data: { orders } }, "*");
            } else if (type === "CLOSE_APP") {
                document.body.removeChild(iframe);
                window.removeEventListener("message", onMessage);

                yes();
            }
        }

        window.addEventListener("message", onMessage);
    });
}
